import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../../Styles/Colors';
import { FORM } from './formStyles';

const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
`;

const FieldLabel = styled.label`
  font-size: ${FORM.labelSize};
  font-weight: 600;
  color: ${FORM.text};
  line-height: 1.4;
`;

const RequiredMark = styled.span`
  color: ${COLORS.red};
  margin-left: 2px;
`;

const FieldHint = styled.span`
  display: block;
  color: ${FORM.textMuted};
  font-size: ${FORM.hintSize};
  line-height: 1.45;
`;

const FieldError = styled.span`
  display: block;
  color: ${COLORS.red};
  font-size: ${FORM.hintSize};
  line-height: 1.45;
`;

interface FormFieldProps {
  label?: string;
  htmlFor?: string;
  required?: boolean;
  hint?: string;
  error?: string;
  children: React.ReactNode;
  className?: string;
}

export const FormField: React.FC<FormFieldProps> = ({
  label,
  htmlFor,
  required,
  hint,
  error,
  children,
  className,
}) => (
  <FieldWrapper className={className}>
    {label && (
      <FieldLabel htmlFor={htmlFor}>
        {label}
        {required && <RequiredMark>*</RequiredMark>}
      </FieldLabel>
    )}
    {children}
    {error ? <FieldError>{error}</FieldError> : hint ? <FieldHint>{hint}</FieldHint> : null}
  </FieldWrapper>
);

export { RequiredMark, FieldHint, FieldError };
